<template>
	<div class="items-list--item">
		<b-row align-v="center">
			<b-col md="3">
				<div class="items-list--item-label">Datum</div>
				{{ transaction.timeStamp | dateTime }}
			</b-col>
			<b-col md="6">
				<div class="items-list--item-label">Produkt</div>
				<div
					v-for="item in transaction.items"
					:key="item.id"
					class="item-list--item-product"
				>
					{{ item.product.label }}
				</div>
			</b-col>
			<b-col md="1">
				<div class="items-list--item-label">Betrag</div>
				<div class="items-list--item-amount">
					<span v-if="transaction.type.token">{{ transaction.tokenAmount }} Token</span>
					<span v-if="transaction.type.fiat">{{ transaction.totalGrossAmountFormatted | moneyAmount }}</span>
				</div>
			</b-col>
			<b-col md="2">
				<div class="items-list--item-actions">
					<a
						v-if="transaction.invoice"
						:href="'/transaktion/' + transaction.id + '/rechnung'"
						v-b-tooltip
						title="Rechnung (PDF)"
						target="_blank"
					>
						<Icon icon="invoice" />
					</a>
				</div>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import Icon from "@/vue/icon/Icon"

export default {

	components: {
		Icon,
	},

	props: {
		transaction: {
			type: Object,
			required: true,
		},
	},
}
</script>
